import {Injectable} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import * as CmsActions from '../actions/cms.actions';
import {CmsService} from '../services/cms.service';
import {of, tap} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';
import {GlobalMessage, GlobalMessageType} from '../../core/models/global-message';
import * as GlobalMessageActions from '../../core/actions/global-message.actions';
import {FilterConditionType, FilterField, SortDirection, SortField} from "../../shared/models/magento-search-filter";
import {CmsResult} from "../models/cms-blocks";
import {LanguageService} from "../../core/services/language.service";

@Injectable()
export class CmsEffects {

    loadBlock$ = createEffect(() => this.actions$
        .pipe(
            ofType(CmsActions.loadCmsBlock),
            mergeMap((block) => {
                const blockId = block.blockId;
                console.log('Loading CMS block', blockId);

                return this.cmsService
                    .getBlock(block.blockId)
                    .pipe(
                        map(block => CmsActions.loadCmsBlockSuccess({block})),
                        catchError(() => of(CmsActions.loadCmsBlockFailure({blockId})))
                    )
            })
        ));

    $loadBlocks = createEffect(() => this.actions$
        .pipe(
            ofType(CmsActions.loadCmsBlocks),
            tap(action => console.log('load blocks', action)),
            mergeMap(() => {
                const query = {
                    pageSize: 100,
                    page: 1,
                    filterGroups: [{
                        filters: [{
                            field: FilterField.IDENTIFIER,
                            value: `cms_%_${this.languageService.getCurrentLanguage().label.toLowerCase()}`,
                            conditionType: FilterConditionType.LIKE
                        }]
                    }],
                    sortOrders: [
                        {
                            field: SortField.IDENTIFIER,
                            direction: SortDirection.ASC
                        }
                    ]
                };

                return this.cmsService
                    .getBlockList(query)
                    .pipe(
                        map((result: CmsResult) =>
                            CmsActions.loadCmsBlocksSuccess({cmsBlocks: result.cmsBlocks})),
                        catchError(() => of(CmsActions.loadCmsBlocksFailure()))
                    )
            })
        ));

    loadingBlockFailure$ = createEffect(() => this.actions$
        .pipe(
            ofType(CmsActions.loadCmsBlockFailure),
            mergeMap(action => {
                    const message: GlobalMessage = {
                        id: 'cms-load-error',
                        type: GlobalMessageType.ERROR,
                        message: `A CMS-component couldn't be loaded: ${action.blockId}`
                    };
                    return of(GlobalMessageActions.addMessage({globalMessage: message}));
                }
            )
        ));

    loadingBlocksFailure$ = createEffect(() => this.actions$
        .pipe(
            ofType(CmsActions.loadCmsBlocksFailure),
            mergeMap(() => {
                    const message: GlobalMessage = {
                        id: 'cms-blocks-load-error',
                        type: GlobalMessageType.ERROR,
                        message: `CMS components couldn't be loaded`
                    };
                    return of(GlobalMessageActions.addMessage({globalMessage: message}));
                }
            )
        ));

    constructor(private actions$: Actions, private cmsService: CmsService,
                private languageService: LanguageService) {
    }
}
